import React from "react";
import styled from "styled-components";
import { useDispatch } from "react-redux";
import { setViewReportIssueModal } from "features/settings/settingSlice";
import { TbMessageReport } from "react-icons/tb";
import { useTranslation } from "react-i18next";

export default function GiveFeedback() {
  const { t } = useTranslation("feedback");

  const dispatch = useDispatch();

  const handleClick = () => {
    dispatch(setViewReportIssueModal(true));
  };

  return (
    <GiveFeedbackContainer onClick={handleClick}>
      <TbMessageReport size={19} />
      <span>{t("quick")}</span>
    </GiveFeedbackContainer>
  );
}

const GiveFeedbackContainer = styled.button`
  border-radius: 25px;
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  height: 50px;
  font-size: 13px;
  font-weight: 500;
  color: var(--lightThemeFontColor);
  background-color: var(--extrasItemBg);
  border: 1px solid var(--borderColor);
  cursor: pointer;
  margin-top: 20px;
  width: 190px;
  bottom: 20px;
  left: 20px;
  position: absolute;

  &:hover {
    background-color: #e0e0e0;
    color: #424242;
  }
`;
